export default "__VITE_ASSET__47w_DGUX__"